import { AulaDispatch } from '@core/types/state';
import { INBOX_CHANGE_CONVERSATION_PARTICIPANTS } from '../actions';
import { SelectedUser } from '../types';

const changeConversationParticipants =
  (newValue: SelectedUser[]) => (dispatch: AulaDispatch) => {
    dispatch({
      type: INBOX_CHANGE_CONVERSATION_PARTICIPANTS,
      payload: newValue,
    });
  };

export default changeConversationParticipants;
